export default __webpack_public_path__ + "static/media/HOMER_Service_Terms.bb7f8280.pdf";